<template>
    <div class="row">
        <div class="col-12 col-md-6" v-for="(download, index) in downloads">

            <div :class="'global-download '+(download.src ? 'global-download--with-image' : 'global-download--with-icon')">
                <template v-if="download.src">
                    <a class="global-download--image" :href="download.href" target="_blank" :data-dlcat="trackingCategory(download)" :data-dlid="trackingId(download)">
                        <img :src="download.src" class="img-fluid" width="112" :alt="download.title"/>
                    </a>
                </template>
                <template v-else>
                        <a class="global-download--icon button button--ghost button--icon icon--before icon--download" :href="download.href" target="_blank" :data-dlcat="trackingCategory(download)" :data-dlid="trackingId(download)"></a>
                </template>
                <div class="global-download--properties">
                    <a :href="download.href" target="_blank" :data-dlcat="trackingCategory(download)" :data-dlid="trackingId(download)">
                        <p class="global-download--title"><b>{{download.title}}</b></p>
                        <span class="global-download--file"><span class="global-download--file-type">{{download.ext}}</span>&nbsp;({{download.size}})</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from "@search/shared/constants";

export default {
        name: "search-result-downloads",
        props: {
            downloads: Array
        },
		methods: {
            trackingCategory(download) {
                return '' + download.subtype;
            },
            trackingId(download) {
                return download.pim_id + '; '+download.title+'; ' + download.href.replace(/.*\//, '');
            },
			openLink() {
				const scrollOffset = Math.floor(window.pageYOffset); // Damit da kein 2160.23452534532 rauskommt....

				if (this.$store.state.category !== constants.resultKind.all) {
					const activeCat = this.$store.getters.searchResultsForKind(this.$store.state.category);

					// Offset muss hier reduziert werden, da results.length schon das Offset für eine Seite mehr wäre
					const offset = Math.max(activeCat.results.length - constants.resultsPerPage, 0);

					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '&tx_salbase9_search[cat]=' + this.$store.state.category + '#' + offset + ',' + scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
				else {
					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '#0,'+scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
			},
			onImageLoaded() {
			    // console.log('Image loaded');
				this.$emit('image-loaded');
			}
		},
    }
</script>
